module.exports = __webpack_public_path__ + "img/avatar.9505b6c2.jpg";